import {loadPriceTechData, compose, getLang, listen, v$} from './helpers.js';
import handlePopup, {openPopup} from "./popupForm";
import $ from 'jquery';

import select2 from './select2.js';

//handlePopup(v$('#tech-calc-request')[0], v$('#tech-calc-open')[0]);
handlePopup(v$('#tech-calc-result')[0]);

let queryArr = [];
var priceSum;
var price_tech;
loadPriceTechData((function (){
  price_tech = window.price_tech;
}).bind(this));

let memoizeObj = {};

const chainedSelectorsWrap = (parent) => {   // appliances
  let selectors = parent.querySelectorAll('select[data-chained]'),
    multipliers = parent.querySelectorAll('select[data-multiplier], input[data-multiplier]'),
    appliancesResult = v$('.appliances_result', parent)[0],
    equipmentTypeSelect = v$('select[data-type="equipment_type"]', parent)[0],
    brandSelect = v$('select[data-type="brand"]', parent)[0],
    brandSelect2 = $('select[data-type="brand"]'),
    condition = v$('.js-condition')[0],
    warranty = v$('.js-warranty')[0],
    box = v$('.js-box')[0],
    charger = v$('.js-charger')[0],
    modificators = v$('select[data-type="modificators"],input[data-type="modificators"]'),
    modelSelect = v$('select[data-type="model"]', parent)[0],
    modelSelect2 = $('select[data-type="model"]'),
    laptopPopup = v$('#laptop')[0],
    typeLabel = $('select[data-type="equipment_type"]').data('label'),
    brandLabel = $('select[data-type="brand"]').data('label'),
    modelLabel = $('select[data-type="model"]').data('label'),
    autoStateCalc = document.querySelectorAll('.auto-state-calc');
  const resetAllNext = ({nextElemAfterChosenId, id}) => {
    nextElemAfterChosenId.forEach((item) => {
      item.value = '';
      item.nextElementSibling.innerText = '--';
    });
    return id;
  };
  const enableSelector = target => {
    let selectStyled = target.nextElementSibling;
    selectStyled.classList.remove('disabled');
    target.disabled = false;
    return {
      selectStyled,
      target
    }
  };

  const enableSelector2 = ($select2 = modelSelect2) => {
    if($select2 === modelSelect2) {
      setTimeout(() => {
        $select2.attr('disabled', false)
      },2000)
    } else {
      $select2.attr('disabled', false)
    }
  };
  const disableSelector2 = (select2) => {
    select2.attr('disabled', true)
  };
  const resetSelectValue = ({selectStyled, target}) => {
    selectStyled.innerHTML = '--';
    target.value = null;
    return true;
  }
  const resetSelect2Value = (select2 = modelSelect2, label = modelLabel) => {
    console.log('resetSelect2Value label:::', label);

    select2.prepend(new Option(
      label,
      '-1',
      false,
      true
    ));
    return true;
  }
  const showAutoStateCalc = () => {
    autoStateCalc.forEach(item => {
      item.style.display = 'inline-block';
    })
  }
  const hideAutoStateCalc = () => {
    autoStateCalc.forEach(item => {
      item.style.display = 'none';
    })
  }
  const renderSum = sum => {
    $("#tech-calc-request-form input.hash").val(btoa(JSON.stringify(sum)));

    if (sum.from) {
      appliancesResult.innerText = sum !== null ? `${sum.from} - ${sum.to}` : '0';
    }
    else {
      appliancesResult.innerText = sum !== null ? `${sum.value}` : '0';
    }

    priceSum = sum;
    if (sum.value > 0 || sum.from > 0) {
      showAutoStateCalc();
    }
  };

  const multiplySum = (sum) => {
    let multipliersArr = [];
    let multiplier = 1;
    multipliers.forEach(item => {
      if (item.type == "checkbox") {
        let multiplier = item.value;

        multipliersArr.push(item.checked == true ? parseFloat(multiplier) : 1);
      } else {
        multipliersArr.push(parseFloat(item.value));
      }
    });

    const multipliersSum = multipliersArr.reduce((a, b) => a * b);

    if (sum.box !== 0) {
      $('.tech-box').show();
    }
    if (sum.charger !== 0) {
      $('.tech-charger').show();
    }

    multiplier *= (box.checked ? sum.box : 1);
    multiplier *= (charger.checked ? sum.charger : 1);

    if (sum.from) {
      return {
        from: (sum.from * multipliersSum * multiplier).toFixed(0),
        to: (sum.to * multipliersSum * multiplier).toFixed(0)
      }
    }
    return {
      value: (sum.value * multipliersSum * multiplier).toFixed(0)
    }
  }

  const getQueryParams = () => {
    return [equipmentTypeSelect.value, brandSelect.value];
  }

  const sendRequest = queryArr => {
    let resonseData = {};
    if (process.env.NODE_ENV === 'production') {
      const lang = getLang();
      resonseData = $.ajax(`${lang}/price/tech?type=${queryArr[0]}&brand=${queryArr[1]}${window.isOneDay ? '&isOneDay=true' : ''}`)
    } else {
      resonseData = $.ajax('data/price_tech.json');
    }
    return resonseData;
  }
  const memoizeValue = obj => {
    memoizeObj[obj.queryArr[1]] = obj.data;
    return obj;
  }
  const parseResponseObject = obj => {
    return Object.keys(obj.data);
  }
  const removeOld = (arr = [], target = modelSelect) => {
    let ul = v$('ul', target.parentNode)[0],
      firstOption = v$('option', target)[0];
    target.innerHTML = '';
    target.appendChild(firstOption);
    ul.innerHTML = '';
    return arr;
  }
  const renderModelLi = (arr, target = modelSelect) => {
    //Here we render Li
    let ul = v$('ul', target.parentNode)[0];
    arr.forEach((item, index) => {
      let li = document.createElement('li'),
        option = document.createElement('option');
      li.setAttribute('rel', item);
      option.setAttribute('value', item);
      li.innerText = item;
      target.appendChild(option);
      ul.appendChild(li);
    })
    return target;
  }
  const removeOld2 = (arr = [], target = modelSelect2) => {
    target.find("option").remove().trigger("change");
    return arr;
  }
  const renderModelLi2 = (arr, target = modelSelect2) => {
    arr.forEach((item, index) => {
      target.append(new Option(
        item,
        item,
        null,
        false
      ));
    });

    if (arr.length === 0) {
      disableSelector2(target)
    }

    return target;
  }
  const getSumFromMemoize = () => {
    let brandValue = brandSelect.value,
      modelValue = modelSelect.value;
    return memoizeObj[brandValue][modelValue][condition.value][warranty.checked ? 'warrantyPrice' : 'price'];
  }
  const resetSum = () => {
    appliancesResult.innerText = '0';
    hideAutoStateCalc();
  }
  const handleMultipliers = compose(
    renderSum,
    multiplySum,
    getSumFromMemoize
  );
  const handleBrandSelect = compose(
    resetSelect2Value,
    enableSelector2,
    renderModelLi2,
    removeOld2,
    parseResponseObject,
    memoizeValue,
    // resetSelect2Value,
  );
  const handleModificatorsAndModelSelect = compose(
    handleMultipliers
    // renderSum,
    // getSumFromMemoize
    // commented renderSum and getSumFromMemoize
  )
  // renderModelLi(Object.keys(price_tech), equipmentTypeSelect);

  equipmentTypeSelect.addEventListener('change', e => {
    if (e.target.value === 'laptop') {
      openPopup(v$('#laptop')[0]);
      return true;
    }
    $('.tech-box, .tech-charger').hide();
    box.checked = false;
    charger.checked = false;
    removeOld2(null, brandSelect2);
    removeOld2(null, modelSelect2);
    enableSelector2(brandSelect2);
    disableSelector2(modelSelect2);
    resetSelect2Value(brandSelect2, brandLabel);
    resetSelect2Value(modelSelect2, modelLabel);
    renderModelLi2(price_tech[e.target.value], brandSelect2);
    resetSum();
    hideTechSum();
  });
  brandSelect.addEventListener('change', e => {
    let queryArr = getQueryParams();
    resetSum();
    if (!memoizeObj[queryArr[1]]) {
      modelSelect.classList.add('activeLoader');
      sendRequest(queryArr).then(data => {
        handleBrandSelect({
          data,
          queryArr
        })

        setTimeout( () => {
          modelSelect.classList.remove('activeLoader');
        },2000)
      })
    } else {
      handleBrandSelect({
        data: memoizeObj[queryArr[1]],
        queryArr
      })
      resetSelect2Value();
    }

    hideTechSum();
  })
  modelSelect.addEventListener('change', () => {
    handleModificatorsAndModelSelect();
    hideTechSum();
  });
  multipliers.forEach((item) => {
    item.addEventListener('change', () => {
      handleMultipliers();
    });
  });
  listen(modificators, 'change', () => {
    handleModificatorsAndModelSelect()
  });
  handlePopup(laptopPopup);

};

export default chainedSelectorsWrap;

$(document).on('click', '#tech-calc-open', function (event) {
  event.preventDefault();

  var resultPriseTech;
  var sum = priceSum;

  if (sum.from) {
    resultPriseTech = sum !== null ? `${sum.from} - ${sum.to}` : '0';
  }
  else {
    resultPriseTech = sum !== null ? `${sum.value}` : '0';
  }

  $('.tech-calc-open-cont .tech-calc-open-cont__sum-value').text(resultPriseTech);

  showTechSum();

  // $($('.tech-after-calc-form .b24-form-field-string')[0]).find('input').val($('select[data-type="equipment_type"]').val());
  // $($('.tech-after-calc-form .b24-form-field-string')[0]).find('input').trigger('input');
  // $($('.tech-after-calc-form .b24-form-field-string')[0]).find('input').get(0).dispatchEvent(new Event('input', { bubbles: true }));

  bitrixDataSet($('.tech-after-calc-form .b24-form-field-string')[0], $('select[data-type="equipment_type"]'));
  bitrixDataSet($('.tech-after-calc-form .b24-form-field-string')[1], $('select[data-type="brand"]'));
  bitrixDataSet($('.tech-after-calc-form .b24-form-field-string')[2], $('select[data-type="model"]'));
});

function bitrixDataSet(bitrixEl, calcInputVal) {
  if($(bitrixEl).length > 0) {
    if( calcInputVal.length > 0) {
      $(bitrixEl).find('input').val(calcInputVal.val());
      // $(bitrixEl).find('input').prop( "disabled", true );
      $(bitrixEl).find('input').get(0).dispatchEvent(new Event('input', { bubbles: true }));
    }

    if($(bitrixEl).find('input').val().length !== 0) {
      $(bitrixEl).find('input').addClass('b24-form-control-not-empty');
    } else {
      $(bitrixEl).find('input').removeClass('b24-form-control-not-empty');
    }
  }
}

function showTechSum(){
  $('.tech-calc-open-cont .tabs_content-result-row_sum').css({"display": "flex"})
  $('.tech-calc-open-cont .tabs_content-result-row_button').css({"display": "none"})
  $('.tech-after-calc-form').css({"display": "block"})
}

function hideTechSum(){
  $('.tech-calc-open-cont .tabs_content-result-row_sum').css({"display": "none"})
  $('.tech-calc-open-cont .tabs_content-result-row_button').css({"display": "flex"})
  $('.tech-after-calc-form').css({"display": "none"})
}

$(document).ready(function () {
  var elements = $(document).find('.js-select2');

  for (var i = 0, l = elements.length; i < l; i++) {
    var $select = $(elements[i]);

    $select.select2({
      dropdownAutoWidth: true,
      width: 'auto',
      dropdownParent: $select.closest('div'),
      //multiple: true,
      //maximumSelectionSize: 1,
      // allowClear: true,
      placeholder: {
        id: '-1', // the value of the option
        text: $select.data('placeholder')
      },
      minimumResultsForSearch: 0
    });




    // Trigger search
    $select.on('keydown', function (e) {
      var $select = $(this),
        $select2 = $select.data('select2'),
        $container = $select2.$container;


      // Unprintable keys
      if (typeof e.which === 'undefined' || $.inArray(e.which,
        [0, 8, 9, 12, 16, 17, 18, 19, 20, 27, 33, 34, 35, 36, 37, 38, 39, 44, 45, 46, 91, 92, 93, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 123, 124, 144, 145, 224, 225, 57392, 63289]) >= 0) {
        return true;
      }

      // Already opened
      if ($container.hasClass('select2-container--open')) {
        return true;
      }

      $select.select2('open');

      // Default search value
      var $search = $select2.dropdown.$search || $select2.selection.$search,
        query = $.inArray(e.which, [13, 40, 108]) < 0 ? String.fromCharCode(e.which) : '';
      if (query !== '') {
        $search.val(query).trigger('keyup');
      }
    });

    $select.on("select2:select", function () {
      let event = new Event("change", {"bubbles": true, "cancelable": false});
      this.dispatchEvent(event);
    });

    // Format, placeholder
    $select.on('select2:open', function () {

      var $select = $(this),
        $select2 = $select.data('select2'),
        $dropdown = $select2.dropdown.$dropdown || $select2.selection.$dropdown,
        $search = $select2.dropdown.$search || $select2.selection.$search,
        data = $select.select2('data');

      // Above dropdown
      if ($dropdown.hasClass('select2-dropdown--above')) {
        $dropdown.append($search.parents('.select2-search--dropdown').detach());
      }

      // Placeholder
      $search.attr('placeholder', (data[0].text !== '' ? data[0].text : $select.data('placeholder')));
    });
  }

  let $model = $("select[data-type='model']");
  let $equip = $("select[data-type='equipment_type']");
  let $brand = $("select[data-type='brand']");
  let $state = $("select[data-type='modificators']");
  let $clientStatus = $("select[data-type='client-status']");
  let $contOpen = $(".tech-calc-open-cont");
  let $contClose = $(".tech-calc-close-cont");
  const showButton = function () {
    setTimeout(function () {
      if ($model.val() !== "-1") {
        $contOpen.show();
        $contClose.hide();
      } else {
        $contOpen.hide();
        $contClose.show();
      }
    }, 400);
  };
  const setDevice = function () {
    setTimeout(function () {
      if ($model.val() !== "-1") {
        $("#tech-calc-request-form input.device").val(btoa(unescape(encodeURIComponent(JSON.stringify({
          type: $equip.val(),
          brand: $brand.val(),
          model: $model.val(),
          state: $state.val(),
          client_status: $clientStatus.val(),
          warranty: $('#radio_warranty').is(':checked'),
          complectationStr: (function(){
            let items = $("#appliances .tabs_content-inner-checkbox_wrap [data-type=\"modificators\"]:checked + label");
            let arr = [];
            for(i = 0; i < items.length; i++){
              arr.push(items[i].innerHTML);
            }
            return arr.join(' ');
          })(),
        })))));
      } else {
        $("#tech-calc-request-form input.device").val("");
      }
    }, 400);
  };
  $state.on("change", setDevice);
  $clientStatus.on("change", setDevice);
  $("#appliances").on('change', '.radio-wrap [data-type="modificators"]', setDevice);
  $model.on("change", setDevice);
  $model.on("change", showButton);
  $equip.on("change", showButton);
  $brand.on("change", showButton);

  var formSubmitting = false;
  $('#tech-calc-request-form').submit((e) => {
      e.preventDefault();
      if (formSubmitting){
        return false;
      }
      formSubmitting = true;
      var form = $(this);
      var url = form.attr('action');

    console.log(form.serialize());
    $.ajax({
        type: "POST",
        url: url,
        data: form.serialize(), // serializes the form's elements.
      });
  });
  // $('.js-select2').each(function() {
  //   $(this).select2({
  //     dropdownAutoWidth : true,
  //     width: 'auto',
  //     dropdownParent: $(this).closest('div'),
  //     //multiple: true,
  //     //maximumSelectionSize: 1,
  //     allowClear: false,
  //     placeholder: $(this).data('placeholder'),
  //     minimumResultsForSearch: 0,
  //   });

  //   // Trigger search
  //   $(this).on('keydown', function (e) {
  //     var $select = $(this),
  //       $select2 = $select.data('select2'),
  //       $container = $select2.$container;


  //     // Unprintable keys
  //     if (typeof e.which === 'undefined' || $.inArray(e.which,
  //       [0, 8, 9, 12, 16, 17, 18, 19, 20, 27, 33, 34, 35, 36, 37, 38, 39, 44, 45, 46, 91, 92, 93, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 123, 124, 144, 145, 224, 225, 57392, 63289]) >= 0) {
  //       return true;
  //     }

  //     // Already opened
  //     if ($container.hasClass('select2-container--open')) {
  //       return true;
  //     }

  //     $select.select2('open');

  //     // Default search value
  //     var $search = $select2.dropdown.$search || $select2.selection.$search,
  //       query = $.inArray(e.which, [13, 40, 108]) < 0 ? String.fromCharCode(e.which) : '';
  //     if (query !== '') {
  //       $search.val(query).trigger('keyup');
  //     }
  //   });

  //   // Format, placeholder
  //   $(this).on('select2:open', function (e) {
  //     var event = new Event("change", {"bubbles":true, "cancelable":false});
  //     this.dispatchEvent(event);

  //     var $select = $(this),
  //       $select2 = $select.data('select2'),
  //       $dropdown = $select2.dropdown.$dropdown || $select2.selection.$dropdown,
  //       $search = $select2.dropdown.$search || $select2.selection.$search,
  //       data = $select.select2('data');

  //     // Above dropdown
  //     console.log($select2.dropdown.$dropdown)
  //     if ($dropdown.hasClass('select2-dropdown--above')) {
  //       $dropdown.append($search.parents('.select2-search--dropdown').detach());
  //     }

  //     // Placeholder
  //     $search.attr('placeholder', (data[0].text !== '' ? data[0].text : $select.data('placeholder')));
  //   });
  // });
});
